module.exports = __webpack_public_path__ + "img/home-icon-green.eecaebb7.svg";